import { UiElement } from '../models/ui-element';
import { UIELEMENT } from './default-uielement';
const uielement = Object.assign({}, UIELEMENT);
export let UIELEMENTS: UiElement[] = [uielement];
